// Valor por defecto de rol.
export const defaultRol = () => {
    return {
        id: null,
        name: null,
        description: null,
    };
};

// Valores por defecto de filterWorkRoles.
export const defaultFilterWorkRoles = () => {
    return {
        search: null,
        page: 1,
        total: 0,
        per_page: 10,
    };
};

// Valores por defecto de workRoles.
export const defaultWorkRoles = () => {
    return [];
}

// Valores por defecto de workRolesActives.
export const defaultWorkRolesActives = () => {
    return [];
}

export default {
    rol: defaultRol(),
    filterWorkRoles: defaultFilterWorkRoles(),
    workRoles: defaultWorkRoles(),
    workRolesActive: defaultWorkRolesActives(),
};
